//@flow
import * as React from 'react'
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Button, useInput } from 'sputnik-ui'
import { SingleChildTemplate } from 'components'
import { Card } from 'components'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import DirectionsIcon from '@material-ui/icons/Directions'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Zoom from '@material-ui/core/Zoom'
import TextField from '@material-ui/core/TextField'

import { searchCitizen } from 'store/citizens/operations'
import { fetchEntriesSync } from 'store/operations'

function Transition(props) {
  return <Zoom direction="up" {...props} />
}

function ListEntries({ open, handleClose, citizens, dispatch, history }) {
  const [entries, setEntries] = useState([])

  useEffect(() => {
    if (citizens.length > 0) {
      const entryUuids = citizens.map((c) => c.flats.map((f) => ( f.parent_uuid ))).flat()
      dispatch(fetchEntriesSync({entryUuids: entryUuids})).then((entries) => {
        setEntries(entries)
      })
    }
  }, [dispatch, citizens])

  const uniqFlats = (array) => {
    const temp = {}
    array.forEach((f) => {
      if(!temp[f.uuid]) {
        temp[f.uuid] = f
      }
    }
    )
    return Object.values(temp).flat()
  }

  const findEntry = (uuid) => {
    return entries.find((e) => e.uuid === uuid)
  }
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      fullWidth
    >
      {/* <SingleChildTemplate style={{ width: '100%' }}> */}
        <Card title="Жители"
              titleIcon={<TransferWithinAStationIcon />}
              style={{ width: '100%', maxWidth: '100%' }}
              >
              {citizens.map(c => (
                uniqFlats(c.flats).map(f => (
                  <ListItem
                      key={f.id}
                      button
                      onClick={() => {
                        history.push(`/f/${f.uuid}`)
                      }}
                    >
                    <ListItemIcon>
                      <DirectionsIcon />
                    </ListItemIcon>
                    <ListItemText 
                      primary={`№${f.number} ` + findEntry(f.parent_uuid)?.short_address} 
                      secondary={`ID жителя ${c.id}`}
                    />
                    <ListItemSecondaryAction style={{ marginRight: '1rem' }}>
                      <ArrowForwardIcon />
                    </ListItemSecondaryAction>
                  </ListItem>  
                ))
              ))}
         </Card>
      {/* </SingleChildTemplate> */}
      <DialogActions>
          <Button onClick={handleClose} secondary rounded tabIndex={-1}>
            отмена
          </Button>
        </DialogActions>
    </Dialog>
  )
}

function SearchCitizen({ open, handleClose, history }) {
  const { value: phoneNumber, bind: bindPhoneNumber } = useInput('')
  const dispatch = useDispatch()
  const citizensError = useSelector(({ citizens }) => !!citizens.error)
  const [showCitizenEntries, setShowCitizenEntries] = useState(false)
  const toggleShowCitizenEntries = () => {
    setShowCitizenEntries(!showCitizenEntries)
  }
  const [citizens, setCitizens] = useState([])
  const handleSubmit = React.useCallback(
    e => {
      e.preventDefault()

      // change first letter of phone number
      let phone = phoneNumber
      if (phoneNumber.match(/^\+/)) {
        phone = phone.slice(1)
      } else if (phoneNumber.match(/^8/)) {
        phone = '7' + phone.slice(1)
      }

      dispatch(searchCitizen(phone)).then((citizen) => {
       setCitizens(citizen)
       setShowCitizenEntries(true)
      }
      )
    },
    [dispatch, phoneNumber, setCitizens, setShowCitizenEntries],
  )

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      PaperProps={{ style: styles.content }}
    >
      <DialogTitle>Найти жителя</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent style={{ paddingTop: 0 }}>
          <TextField
            {...bindPhoneNumber}
            fullWidth
            label="Номер телефона"
            placeholder="88005553535"
            margin="dense"
            autoFocus
            error={citizensError}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} secondary rounded tabIndex={-1}>
            отмена
          </Button>
          <Button
            primary
            variant="contained"
            rounded
            disabled={!phoneNumber || phoneNumber.length < 11}
            type="submit"
          >
            искать
          </Button>
        </DialogActions>
      </form>
      <ListEntries 
        open={showCitizenEntries}
        handleClose={toggleShowCitizenEntries}
        citizens={citizens}
        history={history}
        dispatch={dispatch}
      />
    </Dialog>
  )
}

const styles = {
  content: { width: '45%' },
  submitBtn: { marginLeft: 'auto', marginTop: 16 },
}

export default withRouter(SearchCitizen)
